import { faChevronDown } from "@jewlr/pro-regular-svg-icons/faChevronDown"
import { faChevronUp } from "@jewlr/pro-regular-svg-icons/faChevronUp"
import { faMinus } from "@jewlr/pro-regular-svg-icons/faMinus"
import { faPlus } from "@jewlr/pro-regular-svg-icons/faPlus"
import { faSearchPlus } from "@jewlr/pro-regular-svg-icons/faSearchPlus"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import scroll from "scroll"
import scrollDoc from "scroll-doc"

import { addAddon, removeAddon } from "areas/cart/store/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"
import { cn } from "styles/utils"

import AddonPrice from "./addon-price"

const QtyBtn = ({ className, ...props }) => (
  <Button
    className={cn(
      "bg-grey-4 text-grey-65 border-y-grey-20 w-38 focus:border-primary h-full items-center justify-center border-y focus:border-2 focus:outline-none",
      className
    )}
    {...props}
  />
)

const InternalExclusiveAddon = ({
  addonInDetail,
  item,
  disableActions,
  removeExclusiveAddon,
  addExclusiveAddon,
  setAddonInDetail,
  setAddonInModal,
  toggleAddonDetail,
  toggleAddonModal,
}) => {
  const removing =
    item.addons.findIndex((addon) => addon.id === disableActions.id) != -1 &&
    disableActions.action === "removing"
  const adding =
    disableActions.id === item.code && disableActions.action === "adding"
  const showDetails = addonInDetail?.code === item.code

  return (
    <div
      className="tracking-half desktop:min-w-1/5 tablet:min-w-1/3 desktop:w-1/5 tablet:w-1/3 px-16 text-center"
      data-cy="cart-exclusive-addon"
      key={`dexaddon-${item.id}-${item.code}`}
    >
      {/* Image */}
      <Button
        className="relative focus:-outline-offset-2"
        onClick={() => {
          setAddonInModal(item)
          toggleAddonModal(true)
        }}
      >
        <Image
          alt={item.title}
          height="144px"
          src={item.images[0]}
          title={item.title}
          width="144px"
        />
        <FontAwesomeIcon
          className="text-grey-30 text-16 absolute bottom-0 left-0 m-6"
          icon={faSearchPlus}
        />
      </Button>
      {/* Price */}
      <AddonPrice price={item.price} retail_price={item.retail_price} />
      {/* Add to Carts | Details */}
      {item.addons.length === 0 ? (
        <Button
          className="text-14 tracking-tightest leading-14 w-100 mx-auto mb-8 flex h-28 items-center rounded-sm p-0 font-medium"
          loading={adding}
          onClick={() => {
            if (disableActions.id === "") {
              addExclusiveAddon(item.code, item.type)
            }
          }}
          variant="primary"
        >
          Add to {jewlr_t("Cart")}
        </Button>
      ) : (
        <div
          aria-label={`Added ${item.addons.length} addons to ${jewlr_t(
            "cart"
          )}`}
          className="mb-8 flex h-28 items-center justify-center"
        >
          <QtyBtn
            aria-label={`Remove one from ${jewlr_t("cart")}`}
            className="border-l-grey-20 rounded-bl-md rounded-tl-md border-l"
            onClick={() => {
              if (disableActions.id === "") {
                removeExclusiveAddon(item.addons[0].id)
              }
            }}
          >
            <FontAwesomeIcon
              className="text-14 align-text-bottom"
              icon={removing ? faSpinner : faMinus}
              spin={removing}
            />
          </QtyBtn>
          <div className="border-t-grey-20 border-b-grey-20 leading-14 text-12 flex h-full items-center border-b border-t bg-white px-10 py-6 font-medium tracking-tight">
            {item.addons.length}
          </div>
          <QtyBtn
            aria-label={`Add one to ${jewlr_t("cart")}`}
            className="border-r-grey-20 rounded-br-md rounded-tr-md border-r"
            onClick={() => {
              if (disableActions.id === "") {
                addExclusiveAddon(item.code, item.type)
              }
            }}
          >
            <FontAwesomeIcon
              className="text-14 align-text-bottom"
              icon={adding ? faSpinner : faPlus}
              spin={adding}
            />
          </QtyBtn>
        </div>
      )}
      <Button
        aria-controls="cart-exclusive-addon-details"
        aria-expanded={showDetails}
        className={cn(
          "text-primary text-15 tracking-tightest leading-14 relative mx-auto mb-24 flex items-center justify-center font-medium before:border-transparent after:border-transparent",
          showDetails &&
            "after:border-16 after:border-b-grey-4 tablet:after:block tablet:before:block before:border-16 before:absolute before:top-1/2 before:hidden before:h-0 before:w-0 before:border-b-white after:absolute after:top-1/2 after:hidden after:h-0 after:w-0"
        )}
        onClick={() => {
          if (showDetails) {
            toggleAddonDetail(false)
            setAddonInDetail({})
          } else {
            toggleAddonDetail(true)
            setAddonInDetail(item)
          }
        }}
      >
        Details
        <FontAwesomeIcon
          className="text-8 ml-8 align-text-bottom"
          icon={showDetails ? faChevronUp : faChevronDown}
        />
      </Button>
    </div>
  )
}

const mapStateToProps = (state) => {
  const addons = state.cart.addons.filter(
    (a) => a.addon_type === "BUNDLE" || a.addon_type === "GIFT_CARD"
  )
  const premiumGiftOffers = state.cart.premium_gift_offers.map((offer) => ({
    addons: addons.filter(({ addon_code }) => addon_code === offer.code),
    ...offer,
  }))

  return {
    premiumGiftOffers,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addExclusiveAddon: (addon_code, addon_type) => {
      dispatch(
        addAddon(
          addon_code,
          addon_type,
          "cart_desktop",
          ownProps.toggleDisableActions
        )
      )

      // scroll to exclusive addon section
      const { exclusiveAddonsRef } = ownProps.refs
      const page = scrollDoc()
      if (exclusiveAddonsRef) {
        const offset = exclusiveAddonsRef.offsetTop - 140
        scroll.top(page, offset)
      }
    },
    removeExclusiveAddon: (addon_id) => {
      dispatch(removeAddon(addon_id, ownProps.toggleDisableActions))
    },
  }
}

InternalExclusiveAddon.propTypes = {
  addExclusiveAddon: PropTypes.func,
  addonInDetail: PropTypes.object,
  disableActions: PropTypes.object,
  item: PropTypes.object,
  refs: PropTypes.object,
  removeExclusiveAddon: PropTypes.func,
  setAddonInDetail: PropTypes.func,
  setAddonInModal: PropTypes.func,
  toggleAddonDetail: PropTypes.func,
  toggleAddonModal: PropTypes.func,
  toggleDisableActions: PropTypes.func,
}
QtyBtn.propTypes = {
  className: PropTypes.string,
}

const ExclusiveAddons = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalExclusiveAddon)

export default ExclusiveAddons
